import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
  selector: 'app-dashboard-selector',
  templateUrl: './dashboard-selector.component.html',
  styleUrls: ['./dashboard-selector.component.scss']
})
export class DashboardSelectorComponent implements OnInit {
  constructor(
    private router: Router,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    if (!['ROOT', 'INTERNAL'].includes(this.loginService.userType)) {
      void this.router.navigate(['/']);
    }
  }

  select(view: 'fortune' | 'fusionLease' | 'boardSales'): void {
    void this.router.navigate(['/'], { queryParams: { view } });
  }
}
